import '@fortawesome/fontawesome-pro/css/all.css'

export default {
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        /* color schema by Daniel Barnbeck */
        primary: '#1B3E5E',
        primary75: '#546E86',
        primary50: '#8D9FAE',
        primary25: '#C6CFD7',
        primary10: '#E8ECEF',

        red: '#DC1E46',
        error: '#DC1E46',
        red75: '#E55674',
        red50: '#ED8FA2',
        red25: '#F6C7D1',
        red10: '#FBE9EC',

        blue: '#2699D6',
        blue75: '#5CB2E0',
        blue50: '#93CCEB',
        blue25: '#C9E5F5',
        blue10: '#E9F5FB',

        magenta: '#89285D',
        magenta75: '#A65E86',
        magenta50: '#C493AE',
        magenta25: '#E1C9D6',
        magenta10: '#F3EAEF',
        // to be continued
        /* end of color schema */
        black20: '#f2f2f2',
        black80: '#333333',
        grey: '#bfbfbf',
        pe: {
          primary: '#DC1E46',
          primaryLight: '#F4BBC7',
          secondary: '#2599D5',
          secondaryLight: '#D3EAF6',
          magenta: '#87285D',
        },
      },
    },
  },
}
